import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream-light font-sans text-brand-brown selection:bg-brand-pink-mid selection:text-brand-brown" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Nav data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Benefits data-id="element-5" />
        <Volumes data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FinalCTA data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <FAQ data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}